import React, { useEffect, useMemo, useState, useRef } from "react";
import { useSelector } from "react-redux";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import classes from "./PRTab.module.css";
import Dbutton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import { useInitialDataLoad, prRepository, offlineQueue, shouldMakeAPICall } from "../../../offline";

import {
  Autocomplete,
  Box,
  Chip,
  Fade,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  IconButton,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { Tooltip } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CancelIcon from "@mui/icons-material/Cancel";
import CircularProgress from "@mui/material/CircularProgress";

import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";

import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import { saveAs } from "file-saver";
import PRSampleItemsList from "../../../assets/files/PRSampleItemsList.csv";
import { EditNote } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import { useLocation } from "react-router-dom";

export const PurchaseRequisitionTab = () => {
  const loginData = useSelector((state) => state.loginData.value);

  const [user_access_type] = useState(loginData?.access_type);
  const [auth_token] = useState(loginData?.auth_token);
  const [user_token] = useState(loginData?.user?.token);
  const [org_id] = useState(loginData?.user?.org_id);

  const [user_details] = useState({
    shipping_address1: loginData.user.address_line,
    city: loginData.user.city,
    country: loginData.user.country,
    state: loginData.user.state,
    postal_code: loginData.user.postal_code,
    phone_number: loginData.user.phone_number,
  });

  const [proceedRFQ, setProceedRFQ] = useState(false);
  const [viewpr, setViewPR] = useState(false);

  const [glcode, setGLCode] = useState([]);
  const [constcenter, setCostCenter] = useState([]);
  const [projectcode, setProjectCode] = useState([]);
  const [selectedPRCode, setSelectedPRCode] = useState("");

  const [budgetRows, setBudgetRows] = useState([
    { costCentre: "", projectCode: "", glCode: "" },
  ]);

  const [getItemMaster, setItemMaster] = useState([]);
  const [reasontext, setReasonText] = useState("");
  const [getpurchaserequestdata, setPurchaseRequestData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  // Track when we just did an optimistic update to prevent useEffect from overwriting
  const justUpdatedOptimistically = useRef(false);

  // Search and Filter states
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const [getpurchasecode, setPurchaseCode] = useState([]);
  const [getuserlist, setUserList] = useState([]);
  const [loadingPR, setLoadingPR] = useState(false);

  const [items, setItems] = useState([
    {
      itemName: "",
      itemCode: "",
      quantity: "",
      unit: "",
      hsnCode: "",
      partnumber: "",
      description: "",
      unitPrice: "",
      totalPrice: "",
    },
  ]);

  const [vendorsList, setVendorsList] = useState({
    values: {
      tokens: [],
      visibleOption: [],
    },
  });
  const [buyerUserDetails, setBuyerUserDetails] = useState({});
  const [selectedApprovers, setSelectedApprovers] = useState([]);
  const [hasMappedPRs, setHasMappedPRs] = useState(false);
  const [inputMethod, setInputMethod] = useState("xls");
  const [fileUpload, setFileUpload] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [viewraisedpr, setViewRaisedPR] = useState(false);
  const [getuserpopupherotext, setUserPopupHeroText] = useState("");
  const [getuserpopupdescription, setUserPopupdescription] = useState("");
  const [successpopup, setSuccessPopUp] = useState(false);
  const [editpr, setEditPR] = useState(false);
  const [getprtoken, setPRToken] = useState({ pr_token: "" });
  const [loadingPRs, setLoadingPRs] = useState(true);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);
  const [prCode, setPRCode] = useState("");
  const [fileuploadError, setFileuploadError] = useState("");
  const [prDate, setPRDate] = useState(null);

  const location = useLocation();

  const unitsOptions = [
    "Assemblies",
    "Dozen",
    "Each",
    "Feet",
    "Gallons",
    "Kilo",
    "Liters",
    "Metric Tons",
    "Meters",
    "Pieces",
    "Pounds",
    "Sets",
    "Tons",
    "Yards",
  ];

  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;
  const financialYear = `${currentYear}-${nextYear}`;
  const currentMonth = new Date()
    .toLocaleString("en-US", { month: "short" })
    .toUpperCase();

  // Filter the data based on search term and status filter
  const filteredPRs = useMemo(() => {
    if (
      !Array.isArray(getpurchaserequestdata) ||
      getpurchaserequestdata.length === 0
    ) {
      return [];
    }

    const filtered = getpurchaserequestdata.filter((pr) => {
      // Search filter
      const matchesSearch =
        searchTerm === "" ||
        pr.pr_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (pr.items?.[0]?.item_name || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        (pr.items?.[0]?.item_code || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        pr.buyer_name?.toLowerCase().includes(searchTerm.toLowerCase());

      // Status filter
      let matchesStatus = true;
      if (statusFilter !== "all") {
        if (statusFilter === "1") {
          matchesStatus = pr.pr_approval_status === "Approved";
        } else if (statusFilter === "2") {
          matchesStatus = pr.pr_approval_status === "Pending";
        } else if (statusFilter === "3") {
          matchesStatus =
            pr.pr_approval_status === "Rejected" ||
            pr.pr_approval_status === "Cancelled";
        }
      }

      return matchesSearch && matchesStatus;
    });
    
    // Debug logging
    const newPRs = filtered.filter(pr => pr._pendingSync || pr._tempToken);
    if (newPRs.length > 0) {
      console.log('🔍 Filtered PRs - New PRs found:', newPRs.map(pr => ({
        pr_code: pr.pr_code,
        pr_token: pr.pr_token,
        matches_search: searchTerm === "" || pr.pr_code?.toLowerCase().includes(searchTerm.toLowerCase()),
        matches_status: statusFilter === "all" || pr.pr_approval_status === (statusFilter === "2" ? "Pending" : statusFilter === "1" ? "Approved" : ""),
        approval_status: pr.pr_approval_status,
      })));
    }
    
    console.log('🔍 Filtered PRs:', {
      total: getpurchaserequestdata.length,
      filtered: filtered.length,
      searchTerm,
      statusFilter,
      newPRs_count: newPRs.length,
    });
    
    return filtered;
  }, [getpurchaserequestdata, searchTerm, statusFilter]);

  // Paginate the filtered results
  const paginatedPurchaseRequests = useMemo(() => {
    if (filteredPRs.length === 0) {
      console.log('🔍 No filtered PRs to paginate');
      return [];
    }

    if (!rowsPerPage || rowsPerPage < 0) {
      return filteredPRs;
    }

    const start = page * rowsPerPage;
    const paginated = filteredPRs.slice(start, start + rowsPerPage);
    
    // Debug: Check if new PR is in paginated results
    const newPRsInPage = paginated.filter(pr => pr._pendingSync || pr._tempToken);
    if (newPRsInPage.length > 0) {
      console.log('✅ New PR found in paginated results:', newPRsInPage.map(pr => pr.pr_code));
    } else {
      const newPRsInFiltered = filteredPRs.filter(pr => pr._pendingSync || pr._tempToken);
      if (newPRsInFiltered.length > 0) {
        console.log('⚠️ New PR is in filteredPRs but not in current page. Page:', page, 'Total filtered:', filteredPRs.length);
      }
    }
    
    return paginated;
  }, [filteredPRs, page, rowsPerPage]);

  // Reset page when filters change
  useEffect(() => {
    setPage(0);
  }, [searchTerm, statusFilter]);

  // Debug: Log when getpurchaserequestdata changes
  useEffect(() => {
    const newPRs = getpurchaserequestdata.filter(pr => pr._pendingSync || pr._tempToken);
    if (newPRs.length > 0) {
      console.log('🔍 State changed - New PRs in getpurchaserequestdata:', {
        total_prs: getpurchaserequestdata.length,
        new_prs_count: newPRs.length,
        new_prs: newPRs.map(pr => ({
          pr_code: pr.pr_code,
          pr_token: pr.pr_token,
          approval_status: pr.pr_approval_status,
          buyer_name: pr.buyer_name,
          has_items: pr.items?.length > 0,
        })),
      });
    }
  }, [getpurchaserequestdata]);

  // Debug: Log when filteredPRs changes
  useEffect(() => {
    const newPRsInFiltered = filteredPRs.filter(pr => pr._pendingSync || pr._tempToken);
    if (newPRsInFiltered.length > 0) {
      console.log('✅ New PR found in filteredPRs:', {
        filtered_total: filteredPRs.length,
        new_prs: newPRsInFiltered.map(pr => pr.pr_code),
      });
    } else {
      const newPRsInState = getpurchaserequestdata.filter(pr => pr._pendingSync || pr._tempToken);
      if (newPRsInState.length > 0) {
        console.warn('⚠️ New PR is in state but NOT in filteredPRs!', {
          state_total: getpurchaserequestdata.length,
          filtered_total: filteredPRs.length,
          new_prs_in_state: newPRsInState.map(pr => ({
            pr_code: pr.pr_code,
            approval_status: pr.pr_approval_status,
            statusFilter,
            searchTerm,
          })),
        });
      }
    }
  }, [filteredPRs, getpurchaserequestdata, statusFilter, searchTerm]);

  const generatePRCode = () => {
    const pr_code =
      getpurchasecode
        ?.map((rfq) => {
          const match = rfq.pr_code.match(
            /PR-(\d+)\/([^\/]+)\/([\d-]+)\/([A-Z]+)/
          );
          if (match) {
            return {
              number: parseInt(match[1]),
            };
          }
          return null;
        })
        .filter((item) => item !== null) || [];

    const nextPRCode =
      pr_code.length > 0
        ? Math.max(...pr_code.map((item) => item.number)) + 1
        : 1;

    const padded = String(nextPRCode).padStart(3, "0");
    return `PR-${padded}/${loginData.user.company_name}/${financialYear}/${currentMonth}`;
  };

  const departmentDropDown = () => {
    return (
      <Autocomplete
        disablePortal
        options={departmentList}
        getOptionLabel={(option) => option?.name || ""}
        value={selectedDepartment}
        onChange={(e, newVal) => setSelectedDepartment(newVal)}
        isOptionEqualToValue={(option, value) => {
          // Compare by id if available, otherwise by name
          if (option?.id && value?.id) {
            return option.id === value.id;
          }
          return option?.name === value?.name;
        }}
        sx={{ width: 230, m: 1 }}
        disabled={viewpr && !editpr}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Department"
            placeholder="Select department"
            sx={{
              "& .MuiInputBase-root": { fontSize: "14px" },
              "& .MuiInputLabel-root": { fontSize: "14px" },
              "& .MuiAutocomplete-tag": { fontSize: "12px" },
            }}
          />
        )}
      />
    );
  };

  const infoLabelDetails = [
    {
      label: "Requisition Code",
      value: viewpr ? selectedPRCode : prCode,
    },
    {
      label: "Date of Request",
      value: (viewpr || editpr) && prDate
        ? (() => {
            try {
              // If prDate is already in "DD MMMM YYYY" format, return as-is
              if (typeof prDate === 'string' && /^\d{1,2}\s+\w+\s+\d{4}$/i.test(prDate.trim())) {
                return prDate;
              }
              
              // Otherwise, try to parse as Date
              const date = new Date(prDate);
              if (!isNaN(date.getTime())) {
                return date.toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                });
              }
              
              // Fallback to current date if parsing fails
              return new Date().toLocaleDateString("en-GB", {
                day: "numeric",
                month: "long",
                year: "numeric",
              });
            } catch (error) {
              console.error('Error parsing date:', error);
              return new Date().toLocaleDateString("en-GB", {
                day: "numeric",
                month: "long",
                year: "numeric",
              });
            }
          })()
        : new Date().toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
          }),
      size: "30rem",
    },
    {
      label: "Requested By",
      value: viewpr
        ? buyerUserDetails?.first_name || ""
        : loginData?.user?.first_name,
      size: "30rem",
    },
    {
      label: "Email",
      value: viewpr ? buyerUserDetails?.email || "" : loginData?.user?.email,
      size: "30rem",
    },
    {
      label: "Contact Number",
      value: viewpr
        ? buyerUserDetails?.phone_number || ""
        : loginData?.user?.phone_number,
      size: "30rem",
    },
    {
      label: "Department",
      value: departmentDropDown(),
      size: "30rem",
    },
  ];

  const costcentreRequest = async () => {
    try {
      const response = await axios({
        url: `${API_ENDPOINT.cost_center_list}`,
        method: "POST",
        data: {
          buyer_token: user_token,
        },
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });

      const data = response?.data?.data || [];
      setCostCenter(data);
      return data;
    } catch (error) {
      console.error("Error fetching RFQs:", error);
      setCostCenter([]);
      return [];
    }
  };

  const glcodeRequest = async () => {
    try {
      const response = await axios({
        url: `${API_ENDPOINT.gl_code_list}`,
        method: "POST",
        data: {
          buyer_token: user_token,
        },
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });

      const data = response?.data?.data || [];
      setGLCode(data);
      return data;
    } catch (error) {
      console.error("Error fetching RFQs:", error);
      setGLCode([]);
      return [];
    }
  };

  const projectCodeRequest = async () => {
    try {
      const response = await axios({
        url: `${API_ENDPOINT.projects_list}`,
        method: "POST",
        data: {
          buyer_token: user_token,
        },
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });

      const data = response?.data?.data || [];
      setProjectCode(data);
      return data;
    } catch (error) {
      console.error("Error fetching RFQs:", error);
      setProjectCode([]);
      return [];
    }
  };

  const getAllItems = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.view_all_item}`,
        { org_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      if (response.data?.response) {
        setItemMaster(response?.data?.response);
      } else {
        console.error("API response is not an array:", response.data);
        setItemMaster([]);
      }
    } catch (error) {
      console.error("Error fetching items:", error);
      setItemMaster([]);
    }
  };

  const getAllPurchaseRequest = async () => {
    try {
      setLoadingPRs(true);
      
      // OFFLINE MODE: Load from cache first
      if (!shouldMakeAPICall(auth_token, user_token)) {
        console.log('📴 Offline mode - loading PRs from cache');
        const cachedPRs = await prRepository.getAllFromCache();
        setPurchaseRequestData(cachedPRs);
        setLoadingPRs(false);
        return cachedPRs;
      }
      
      const isUser = loginData?.access_type === "User";

      const requestData = isUser
        ? { user_token: user_token }
        : { org_id: org_id };

      // Try combined API first (has all items and full details)
      try {
        const combinedResponse = await axios({
          url: `${API_ENDPOINT.combined_saved_pr_with_items_view}`,
          method: "POST",
          data: requestData,
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        });

        const purchaseRequests = combinedResponse?.data?.purchase_requests || [];
        
        // Transform data to add missing fields
        const transformedPRs = prRepository.transformCombinedPRData(purchaseRequests);
        
        // Preserve optimistic updates: merge with existing cache to keep pending sync PRs
        const existingCache = await prRepository.getAllFromCache();
        const cacheMap = new Map(existingCache.map(pr => [pr.pr_token, pr]));
        
        // Update cache map with API data, but preserve PRs with pending sync
        transformedPRs.forEach(pr => {
          const existingPR = cacheMap.get(pr.pr_token);
          // Only overwrite if PR doesn't have pending sync
          if (!existingPR?._pendingSync) {
            cacheMap.set(pr.pr_token, pr);
          } else {
            console.log(`📱 Preserving optimistic update for PR: ${pr.pr_code}`);
          }
        });
        
        const mergedPRs = Array.from(cacheMap.values());
        setPurchaseRequestData(mergedPRs);

        const isUserInApprovers = mergedPRs.some((pr) =>
          pr.approvers?.some(
            (approver) => approver.name === loginData?.user?.first_name
          )
        );
        setHasMappedPRs(isUserInApprovers);

        // Cache the merged data (preserving optimistic updates)
        await prRepository.saveToCache(mergedPRs);

        return mergedPRs;
      } catch (combinedError) {
        console.warn('Combined API failed, falling back to cache or regular API:', combinedError);
        
        // If network error, use cache
        if (combinedError.code === 'ERR_NETWORK' || combinedError.code === 'ERR_CONNECTION_REFUSED') {
          console.log('📴 Network error - loading from cache');
          const cachedPRs = await prRepository.getAllFromCache();
          setPurchaseRequestData(cachedPRs);
          setLoadingPRs(false);
          return cachedPRs;
        }
        
        // Fallback to regular API
        try {
          const response = await axios({
            url: `${API_ENDPOINT.get_saved_prs}`,
            method: "POST",
            data: requestData,
            headers: {
              Authorization: `Bearer ${auth_token}`,
            },
          });

          const data = response?.data || [];
          
          // Preserve optimistic updates when using fallback API
          const existingCache = await prRepository.getAllFromCache();
          const cacheMap = new Map(existingCache.map(pr => [pr.pr_token, pr]));
          
          data.forEach(pr => {
            const existingPR = cacheMap.get(pr.pr_token);
            if (!existingPR?._pendingSync) {
              cacheMap.set(pr.pr_token, pr);
            }
          });
          
          const mergedPRs = Array.from(cacheMap.values());
          setPurchaseRequestData(mergedPRs);

          const isUserInApprovers = mergedPRs.some((pr) =>
            pr.approvers?.some(
              (approver) => approver.name === loginData?.user?.first_name
            )
          );
          setHasMappedPRs(isUserInApprovers);

          return mergedPRs;
        } catch (fallbackError) {
          console.error('Fallback API also failed, using cache:', fallbackError);
          const cachedPRs = await prRepository.getAllFromCache();
          setPurchaseRequestData(cachedPRs);
          return cachedPRs;
        }
      }
    } catch (error) {
      console.error("Error fetching PRs:", error);
      return [];
    } finally {
      setLoadingPRs(false);
    }
  };

  const getAllDepartment = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.get_Department}`,
        { user_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      setDepartmentList(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  const get_user_mapped_prs = async () => {
    try {
      setLoadingPRs(true);
      const response = await axios({
        url: `${API_ENDPOINT.get_user_mapped_prs}`,
        method: "POST",
        data: { user_token },
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });

      const orderedData = response?.data.sort((a, b) => {
        const aCode = parseInt(a.pr_code.replace(/\D/g, ""), 10);
        const bCode = parseInt(b.pr_code.replace(/\D/g, ""), 10);
        return bCode - aCode;
      });

      setPurchaseRequestData(orderedData);
    } catch (error) {
      console.error("Error fetching mapped PRs:", error);
    } finally {
      setLoadingPRs(false);
    }
  };
  console.log(getpurchaserequestdata);
  const getPRforCode = async () => {
    try {
      const response = await axios({
        url: `${API_ENDPOINT.get_all_saved_prs_code}`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });

      const data = response?.data || [];
      setPurchaseCode(data);
    } catch (error) {
      console.error("Error fetching RFQs:", error);
    }
  };

  const get_all_vendors = async () => {
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.get_all_vendor}`,
      data: {
        org_token: user_token,
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    }).then((res) => {
      setVendorsList({
        values: {
          tokens: Array.isArray(res?.data?.users)
            ? res.data.users.map((vendor) => vendor.token)
            : [],
          visibleOption: Array.isArray(res?.data?.users)
            ? res.data.users.map(
                (vendor) =>
                  `${vendor.company_name} (${vendor.company_official_email})`
              )
            : [],
        },
        fullDetails: Array.isArray(res?.data?.users)
          ? res.data.users.reduce((acc, vendor) => {
              acc[vendor.token] = {
                token: vendor.token,
                companyName: vendor.company_name,
                email: vendor.company_official_email,
                role: vendor.role,
              };
              return acc;
            }, {})
          : {},
      });
    });
  };

  const getAllUserList = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.all_user_list}`,
        { buyer_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      const filteredUsers = response?.data.filter(
        (user) => user.role === "User" && user.token !== user_token
      );

      setUserList(filteredUsers);
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  // useEffect(() => {
  //   const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
  //   if (!chatActionRaw) return;

  //   const { action, pr_code } = JSON.parse(chatActionRaw);

  //   sessionStorage.removeItem("CHAT_ACTION");

  //   if (action === "create_new_pr" || action === "raise") {
  //     handleRaisePR();
  //   }

  //   if (action === "open_pending_prs") {
  //     setStatusFilter("2");
  //   }

  //   if (action === "edit_my_pr" && pr_code && getpurchaserequestdata.length) {
  //     const pr = getpurchaserequestdata.find((p) => p.pr_code === pr_code);
  //     if (pr) handleEditPR(pr);
  //   }
  // }, [getpurchaserequestdata]);

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;

    const { action, pr_code } = JSON.parse(chatActionRaw);

    // consume once
    sessionStorage.removeItem("CHAT_ACTION");

    if (action === "create_new_pr") {
      handleRaisePR();
      return;
    }

    if (action === "open_pending_prs") {
      setStatusFilter("2");
      return;
    }

    if (action === "approve_pr") {
      setStatusFilter("1");
      return;
    }

    if (action === "edit_my_pr" && pr_code) {
      if (!getpurchaserequestdata.length) {
        sessionStorage.setItem(
          "CHAT_ACTION",
          JSON.stringify({ action, pr_code })
        );
        return;
      }

      const pr = getpurchaserequestdata.find((p) =>
        p.pr_code?.toLowerCase().startsWith(pr_code.trim().toLowerCase())
      );

      if (pr) {
        handleEditPR(pr);
      }
    }

    // OPEN / VIEW SPECIFIC PR
    if (action === "open_specific_pr" && pr_code) {
      if (!getpurchaserequestdata.length) {
        sessionStorage.setItem(
          "CHAT_ACTION",
          JSON.stringify({ action, pr_code })
        );
        return;
      }

      const pr = getpurchaserequestdata.find((p) =>
        p.pr_code?.toLowerCase().startsWith(pr_code.trim().toLowerCase())
      );

      if (pr) {
        handleViewPR(pr);
      }
    }

    if (action === "search_pr") {
      if (!getpurchaserequestdata.length) {
        sessionStorage.setItem(
          "CHAT_ACTION",
          JSON.stringify({ action, pr_code })
        );
        setSearchTerm(pr_code);
        return;
      }
    }
  }, [getpurchaserequestdata]);

  // Offline-first data loading
  const {
    prs: offlinePRs,
    costCenters: offlineCostCenters,
    glCodes: offlineGLCodes,
    projectCodes: offlineProjectCodes,
    items: offlineItems,
    departments: offlineDepartments,
    vendors: offlineVendors,
    users: offlineUsers,
    prCodes: offlinePRCodes,
    loading: offlineLoading,
  } = useInitialDataLoad(auth_token, user_token, org_id);

  // Sync offline data to component state
  useEffect(() => {
    // Skip if we just did an optimistic update (prevent overwriting)
    if (justUpdatedOptimistically.current) {
      console.log('⏭️ Skipping useEffect merge - optimistic update just happened');
      return;
    }
    
    if (!offlineLoading) {
      // Update PRs - but preserve optimistic updates
      if (offlinePRs.length > 0) {
        // Merge with existing state to preserve optimistic updates
        setPurchaseRequestData(prevPRs => {
          // If we have existing PRs with pending sync, preserve them
          const pendingPRs = prevPRs.filter(pr => pr._pendingSync || pr._lastUpdated);
          
          if (pendingPRs.length > 0) {
            // Merge: use offlinePRs but keep pending ones from state
            const prMap = new Map(offlinePRs.map(pr => [pr.pr_token, pr]));
            pendingPRs.forEach(pr => {
              // Only preserve if it's not in offlinePRs or if it's newer
              const existingInOffline = prMap.get(pr.pr_token);
              if (!existingInOffline || (pr._lastUpdated && pr._lastUpdated > (existingInOffline._lastUpdated || 0))) {
                prMap.set(pr.pr_token, pr); // Preserve optimistic update
                console.log(`📱 Preserving optimistic update for PR: ${pr.pr_code || pr.pr_token}`);
              }
            });
            const merged = Array.from(prMap.values());
            console.log('📱 Merged PRs, preserving', pendingPRs.length, 'optimistic updates, total:', merged.length);
            return merged;
          }
          
          // No pending updates, use offlinePRs as-is
          console.log('📱 No pending updates, using offlinePRs as-is, count:', offlinePRs.length);
          return [...offlinePRs]; // Force new array reference
        });
        
        const isUserInApprovers = offlinePRs.some((pr) =>
          pr.approvers?.some(
            (approver) => approver.name === loginData?.user?.first_name
          )
        );
        setHasMappedPRs(isUserInApprovers);
      }

      // Update master data
      if (offlineCostCenters.length > 0) setCostCenter(offlineCostCenters);
      if (offlineGLCodes.length > 0) setGLCode(offlineGLCodes);
      if (offlineProjectCodes.length > 0) setProjectCode(offlineProjectCodes);
      if (offlineItems.length > 0) setItemMaster(offlineItems);
      if (offlineDepartments.length > 0) setDepartmentList(offlineDepartments);
      if (offlineVendors.length > 0) {
        setVendorsList({
          values: {
            tokens: offlineVendors.map((vendor) => vendor.token),
            visibleOption: offlineVendors.map(
              (vendor) =>
                `${vendor.company_name} (${vendor.company_official_email})`
            ),
          },
          fullDetails: offlineVendors.reduce((acc, vendor) => {
            acc[vendor.token] = {
              token: vendor.token,
              companyName: vendor.company_name,
              email: vendor.company_official_email,
              role: vendor.role,
            };
            return acc;
          }, {}),
        });
      }
      if (offlineUsers.length > 0) {
        const filteredUsers = offlineUsers.filter(
          (user) => user.role === "User" && user.token !== user_token
        );
        setUserList(filteredUsers);
      }
      if (offlinePRCodes.length > 0) setPurchaseCode(offlinePRCodes);
    }
  }, [
    offlinePRs,
    offlineCostCenters,
    offlineGLCodes,
    offlineProjectCodes,
    offlineItems,
    offlineDepartments,
    offlineVendors,
    offlineUsers,
    offlinePRCodes,
    offlineLoading,
    user_token,
    loginData?.user?.first_name,
  ]);

  // Legacy API calls - kept for backward compatibility and manual refresh
  useEffect(() => {
    // Only call APIs if we have auth tokens and want to force refresh
    // The offline system handles initial load automatically
    if (auth_token && user_token && org_id) {
      // Optional: Force sync on mount (offline system already does this)
      // Uncomment if you want explicit API calls in addition to offline sync
      // getAllPurchaseRequest();
      // costcentreRequest();
      // glcodeRequest();
      // projectCodeRequest();
      // getAllItems();
      // getAllDepartment();
      // get_all_vendors();
      // getAllUserList();
      // getPRforCode();
    }
    
    if (getpurchaserequestdata.length == 0) {
      get_user_mapped_prs();
    }
  }, []);

  const userList = () => {
    return (
      <div style={{ flex: "1" }}>
        <Autocomplete
          multiple
          disablePortal
          options={getuserlist}
          sx={{ width: 300 }}
          getOptionLabel={(option) =>
            viewpr ? `${option.first_name}` : `${option.first_name}`
          }
          value={selectedApprovers}
          onChange={(event, newValue) => setSelectedApprovers(newValue)}
          isOptionEqualToValue={(option, value) => {
            if (option?.token && value?.token) {
              return option.token === value.token;
            }
            if (option?.id && value?.id) {
              return option.id === value.id;
            }
            return option?.email === value?.email;
          }}
          disabled={viewpr && !editpr}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{
                "& .MuiInputBase-root": {
                  fontSize: "14px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "14px",
                },
                "& .MuiAutocomplete-tag": {
                  fontSize: "12px",
                },
              }}
            />
          )}
        />
      </div>
    );
  };

  const approvalsectionlabels = [
    {
      label: "Approver Name",
      value: userList(),
      size: "30rem",
    },
    {
      label: "Designation",
      value: loginData?.user?.designation,
      size: "30rem",
    },
    {
      label: "Signature",
      value: loginData?.user?.first_name,
      size: "30rem",
    },
    {
      label: "Date",
      value: new Date().toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      }),
      size: "30rem",
    },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value, 10);
    setRowsPerPage(Number.isNaN(newRows) ? rowsPerPage : newRows);
    setPage(0);
  };

  useEffect(() => {
    const totalItems = Array.isArray(filteredPRs) ? filteredPRs.length : 0;

    if (!rowsPerPage || rowsPerPage < 0) {
      return;
    }

    const maxPage = Math.max(0, Math.ceil(totalItems / rowsPerPage) - 1);
    if (page > maxPage) {
      setPage(maxPage);
    }
  }, [filteredPRs, rowsPerPage, page]);

  const handleAddItem = () => {
    setItems([
      ...items,
      {
        itemCode: "",
        quantity: "",
        unit: "",
        partNumber: "",
        description: "",
        unitPrice: "",
        totalPrice: "",
      },
    ]);
  };

  const handleRemoveItem = (index) => {
    const filteredItems = items.filter((_, i) => i !== index);
    setItems(filteredItems);
  };

  const addBudgetRow = () => {
    setBudgetRows([
      ...budgetRows,
      { costCentre: "", projectCode: "", glCode: "" },
    ]);
  };

  const removeBudgetRow = (index) => {
    setBudgetRows(budgetRows.filter((_, i) => i !== index));
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    const file = event.dataTransfer.files[0];
    if (file) {
      setFileUpload(file);
      setFileuploadError("");
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileUpload(file);
    setFileuploadError("");
  };

  const handleItemSelection = (index, selectedItem) => {
    const updatedItems = [...items];
    updatedItems[index] = {
      ...updatedItems[index],
      itemName: selectedItem?.item_name || "",
      itemCode: selectedItem?.item_code || "",
      hsnCode: selectedItem?.hsn_code || "",
      category: selectedItem?.category || "",
      description: selectedItem?.item_name || "",
    };
    setItems(updatedItems);
  };

  const updateTotalPrice = (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = value;

    const qty = parseFloat(updatedItems[index].quantity) || 0;
    const price = parseFloat(updatedItems[index].unitPrice) || 0;
    updatedItems[index].totalPrice = (qty * price).toFixed(2);

    setItems(updatedItems);
  };

  const grandTotal = items.reduce(
    (acc, item) => acc + parseFloat(item.totalPrice || 0),
    0
  );

  const handleChange = (index, field, value) => {
    const updated = [...budgetRows];
    updated[index][field] = value;
    setBudgetRows(updated);
  };

  const handleSavePurchaseRequest = async () => {
    setLoadingPR(true);
    setFileuploadError("");

    try {
      const now = new Date();
      const oneMonthLater = new Date();
      oneMonthLater.setMonth(now.getMonth() + 1);

      const bidEndTime = new Date(oneMonthLater);
      bidEndTime.setHours(23, 59, 59, 999);
      const formData = new FormData();

      formData.append("user_token", user_token);
      formData.append("org_id", org_id);
      formData.append("PR Code", selectedPRCode || generatePRCode());
      formData.append("Bid Type", 0);
      formData.append("Proposal Document", "");
      formData.append("purchase_request_number", "");
      formData.append(
        "shipping_address1",
        user_details.shipping_address1 || ""
      );
      formData.append(
        "shipping_address2",
        user_details.shipping_address2 || ""
      );
      formData.append("city", user_details.city || "");
      formData.append("state", user_details.state || "");
      formData.append("country", user_details.country || "");
      formData.append("mobile_number", user_details.phone_number || "");
      formData.append("pincode", user_details.postal_code || "");
      formData.append("purchase_reason", reasontext);
      formData.append("dept_name", selectedDepartment?.name || "");

      formData.append("bid_from_date", now.toISOString());
      formData.append("bid_to_date", oneMonthLater.toISOString());
      formData.append("bid_time", bidEndTime.toISOString());

      // IMPORTANT: Only add pr_token for UPDATE actions, NOT for CREATE
      // For CREATE, the server will generate a new pr_token
      // Adding pr_token to CREATE will cause the API to fail
      if (editpr && getprtoken?.pr_token) {
        formData.append("pr_token", getprtoken.pr_token);
        console.log('📝 UPDATE action - added pr_token:', getprtoken.pr_token);
      } else if (!editpr) {
        console.log('📝 CREATE action - NOT adding pr_token (server will generate new one)');
        // Ensure pr_token is NOT in FormData for create
        // Don't add it even if getprtoken has a value from previous operations
      }

      if (inputMethod === "manual") {
        const cleanedItems = items.map((item) => ({
          ...item,
          unitPrice: parseFloat(item.unitPrice) || 0,
          totalPrice: parseFloat(item.totalPrice) || 0,
        }));
        formData.append("items", JSON.stringify(cleanedItems));
      } else if (fileUpload) {
        formData.append("item_code_xlsx", fileUpload);
      } else if (editpr && !fileUpload) {
        const cleanedItems = items.map((item) => ({
          ...item,
          unitPrice: parseFloat(item.unitPrice) || 0,
          totalPrice: parseFloat(item.totalPrice) || 0,
        }));
        formData.append("items", JSON.stringify(cleanedItems));
      }

      const cleanedBudget = budgetRows.map((row) => ({
        cost_center: row.costCentre,
        projectCode: row.projectCode,
        glCode: row.glCode,
      }));

      const simplifiedBudget = cleanedBudget.map((row) => ({
        costCenterCode: row.cost_center?.costcenter_code || "",
        projectCode: row.projectCode?.project_code || "",
        glCode: row.glCode?.gl_code || "",
      }));

      formData.append("budgetDetails", JSON.stringify(simplifiedBudget));

      const approversPayload = selectedApprovers.map((approver) => ({
        token: approver.token,
        name: `${approver.first_name}`,
        email: approver.email,
      }));

      formData.append("approvers", JSON.stringify(approversPayload));
      formData.append("vendorInfo", JSON.stringify([]));

      // NOTE: pr_token is already handled above (line 1144-1151)
      // No need to add it again here - it's already been added if editpr is true

      // Check if online
      const isOnline = shouldMakeAPICall(auth_token, user_token);

      if (!isOnline) {
        // OFFLINE MODE: Queue the action
        console.log('📴 Offline mode - queuing PR update');
        
        try {
          const actionType = editpr ? 'update' : 'create';
          await offlineQueue.enqueue(
            actionType,
            API_ENDPOINT.ins_purchase_request,
            formData
          );

          // Optimistic update: Update local cache
          try {
            const cachedPRs = await prRepository.getAllFromCache();
            
            if (editpr && getprtoken?.pr_token) {
              // UPDATE EXISTING PR
              const prIndex = cachedPRs.findIndex(pr => pr.pr_token === getprtoken.pr_token);
              
              if (prIndex !== -1) {
                const now = new Date();
                const oneMonthLater = new Date(now);
                oneMonthLater.setMonth(now.getMonth() + 1);
                const bidEndTime = new Date(oneMonthLater);
                bidEndTime.setHours(23, 59, 59, 999);
                
                // Get shipping address from buyerUserDetails or user_details
                const shippingData = buyerUserDetails || user_details || {};
                
                // Create updated PR object matching combined API structure
                const updatedPR = {
                  ...cachedPRs[prIndex],
                  request_reason: reasontext,
                  dept_name: selectedDepartment?.name || "",
                  shipping_address: shippingData.shipping_address1 || shippingData.address_line || "",
                  // Update buyer_user with shipping details
                  buyer_user: {
                    ...(cachedPRs[prIndex].buyer_user || {}),
                    ...buyerUserDetails,
                    address_line: shippingData.shipping_address1 || shippingData.address_line || "",
                    city: shippingData.city || buyerUserDetails?.city || "",
                    state: shippingData.state || buyerUserDetails?.state || "",
                    country: shippingData.country || buyerUserDetails?.country || "",
                    postal_code: shippingData.postal_code || shippingData.pincode || buyerUserDetails?.postal_code || "",
                    phone_number: shippingData.phone_number || shippingData.mobile_number || buyerUserDetails?.phone_number || "",
                  },
                  items: items.map((item, idx) => {
                    const budgetRow = budgetRows[idx] || {};
                    return {
                      item_token: item.itemToken || cachedPRs[prIndex].items?.[idx]?.item_token || "",
                      item_name: item.itemName || "",
                      item_code: item.itemCode || "",
                      hsn_code: item.hsnCode || "",
                      quantity: item.quantity || "",
                      unit: item.unit || "",
                      part_number: item.partnumber || "",
                      description: item.description || "",
                      unit_price: parseFloat(item.unitPrice || 0),
                      total_price: parseFloat(item.totalPrice || 0),
                      cost_center: budgetRow.costCentre?.costcenter_code || budgetRow.costCentre || "",
                      gl_code: budgetRow.glCode?.gl_code || budgetRow.glCode || "",
                      project_code: budgetRow.projectCode?.project_code || budgetRow.projectCode || "",
                    };
                  }),
                  approvers: selectedApprovers.map(approver => ({
                    id: approver.id,
                    first_name: approver.first_name,
                    last_name: approver.last_name,
                    email: approver.email,
                    designation: approver.designation,
                    phone_number: approver.phone_number,
                    status: approver.status || 'Pending',
                  })),
                  // Mark as pending sync so it doesn't get overwritten
                  _pendingSync: true,
                  _lastUpdated: Date.now(),
                };

                // Transform and update cache
                const transformedPRs = prRepository.transformCombinedPRData([updatedPR]);
                cachedPRs[prIndex] = transformedPRs[0];
                
                console.log('💾 Saving optimistic update to cache:', {
                  pr_token: getprtoken.pr_token,
                  pr_code: transformedPRs[0].pr_code,
                  request_reason: reasontext,
                  _pendingSync: transformedPRs[0]._pendingSync,
                  total_cached: cachedPRs.length,
                });
                
                // Save to cache FIRST
                await prRepository.saveToCache(cachedPRs);
                console.log('💾 Saved to cache, total PRs:', cachedPRs.length);
                
                // Update component state IMMEDIATELY with the saved data
                // Use the cachedPRs array we just saved (not loading from cache again)
                // Force a new array reference to trigger React re-render
                const updatedPRsArray = [...cachedPRs];
                
                // Mark that we just did an optimistic update
                justUpdatedOptimistically.current = true;
                
                setPurchaseRequestData(updatedPRsArray);
                
                // Reset the flag after a short delay to allow useEffect to run normally later
                setTimeout(() => {
                  justUpdatedOptimistically.current = false;
                }, 1000);
                
                console.log('✅ Optimistically updated PR in state and cache:', {
                  pr_token: getprtoken.pr_token,
                  pr_code: transformedPRs[0].pr_code,
                  request_reason: reasontext,
                  items_count: items.length,
                  _pendingSync: transformedPRs[0]._pendingSync,
                  state_updated: true,
                  state_length: updatedPRsArray.length,
                  updated_pr_index: updatedPRsArray.findIndex(pr => pr.pr_token === getprtoken.pr_token),
                });
                
                // Verify it was saved (async, don't block)
                setTimeout(async () => {
                  const verifyCache = await prRepository.getAllFromCache();
                  const savedPR = verifyCache.find(pr => pr.pr_token === getprtoken.pr_token);
                  if (savedPR && savedPR._pendingSync) {
                    console.log('✅ Verified: Optimistic update persisted in cache');
                  } else {
                    console.warn('⚠️ Warning: Optimistic update may not have persisted');
                  }
                }, 100);
              }
            } else {
              // CREATE NEW PR - Add optimistically to cache
              const tempPRToken = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
              const prCode = selectedPRCode || generatePRCode();
              const now = new Date();
              
              // Create new PR object matching combined API structure
              const newPR = {
                pr_token: tempPRToken, // Temporary token, will be replaced when synced
                pr_code: prCode,
                request_reason: reasontext,
                dept_name: selectedDepartment?.name || "",
                created_on: now.toISOString().split('T')[0], // Format: YYYY-MM-DD
                shipping_address: "",
                buyer_token: user_token,
                buyer_role: loginData?.access_type || "User",
                buyer_user: {
                  first_name: loginData?.user?.first_name || "",
                  last_name: loginData?.user?.last_name || "",
                  email: loginData?.user?.email || "",
                  phone_number: loginData?.user?.phone_number || "",
                  designation: loginData?.user?.designation || "",
                  department: loginData?.user?.department || "",
                  company_name: loginData?.user?.company_name || "",
                  city: loginData?.user?.city || "",
                  state: loginData?.user?.state || "",
                  country: loginData?.user?.country || "",
                  postal_code: loginData?.user?.postal_code || "",
                  address_line: loginData?.user?.address_line || "",
                },
                items: items.map((item, idx) => {
                  const budgetRow = budgetRows[idx] || {};
                  return {
                    item_token: item.itemToken || "",
                    item_name: item.itemName || "",
                    item_code: item.itemCode || "",
                    hsn_code: item.hsnCode || "",
                    quantity: item.quantity || "",
                    unit: item.unit || "",
                    part_number: item.partnumber || "",
                    description: item.description || "",
                    unit_price: parseFloat(item.unitPrice || 0),
                    total_price: parseFloat(item.totalPrice || 0),
                    cost_center: budgetRow.costCentre?.costcenter_code || budgetRow.costCentre || "",
                    gl_code: budgetRow.glCode?.gl_code || budgetRow.glCode || "",
                    project_code: budgetRow.projectCode?.project_code || budgetRow.projectCode || "",
                    created_date: now.toISOString().split('T')[0],
                    updated_date: now.toISOString().split('T')[0],
                  };
                }),
                approvers: selectedApprovers.map(approver => ({
                  id: approver.id,
                  first_name: approver.first_name,
                  last_name: approver.last_name,
                  email: approver.email,
                  designation: approver.designation,
                  phone_number: approver.phone_number,
                  status: approver.status || 'Pending',
                })),
                // Mark as pending sync
                _pendingSync: true,
                _tempToken: tempPRToken,
              };

              // Transform and add to cache
              const transformedPRs = prRepository.transformCombinedPRData([newPR]);
              const updatedPRs = [...cachedPRs, transformedPRs[0]];
              
              // Save to cache FIRST
              await prRepository.saveToCache(updatedPRs);
              console.log('💾 Saved new PR to cache, total PRs:', updatedPRs.length);
              
              // Update component state IMMEDIATELY with the saved data
              // Force a new array reference to trigger React re-render
              const newPRsArray = [...updatedPRs];
              
              // Mark that we just did an optimistic update
              justUpdatedOptimistically.current = true;
              
              // Log before state update
              console.log('🔍 Before state update:', {
                current_state_length: getpurchaserequestdata.length,
                new_array_length: newPRsArray.length,
                new_pr_code: transformedPRs[0].pr_code,
                new_pr_token: transformedPRs[0].pr_token,
              });
              
              setPurchaseRequestData(newPRsArray);
              
              // Force a re-render by updating a dependency
              // The state update should trigger filteredPRs and paginatedPurchaseRequests to recalculate
              console.log('🔄 State updated, React should re-render with new PR');
              
              // Verify the new PR is in state
              console.log('🔍 Verifying new PR in state:', {
                state_length: newPRsArray.length,
                new_pr_index: newPRsArray.findIndex(pr => pr.pr_token === transformedPRs[0].pr_token),
                new_pr_code: transformedPRs[0].pr_code,
                new_pr_approval_status: transformedPRs[0].pr_approval_status,
                has_buyer_name: !!transformedPRs[0].buyer_name,
                has_items: transformedPRs[0].items?.length > 0,
              });
              
              // Reset the flag after a short delay
              setTimeout(() => {
                justUpdatedOptimistically.current = false;
                // Verify it's still in state after delay
                console.log('🔍 After delay - checking state:', {
                  state_length: getpurchaserequestdata.length,
                  new_pr_still_exists: getpurchaserequestdata.some(pr => pr.pr_token === transformedPRs[0].pr_token),
                });
              }, 1000);
              
              console.log('✅ Optimistically created PR in state and cache:', {
                pr_token: transformedPRs[0].pr_token,
                pr_code: transformedPRs[0].pr_code,
                request_reason: reasontext,
                _pendingSync: transformedPRs[0]._pendingSync,
                state_updated: true,
                state_length: newPRsArray.length,
              });
            }
          } catch (cacheError) {
            console.error('Error updating cache optimistically:', cacheError);
            // Continue anyway - queue is still saved
          }
        } catch (queueError) {
          console.error('Error queuing action:', queueError);
          // Still show popup even if queue fails
        }

        // Show success message (optimistic) - ALWAYS show, even if queue/cache fails
        const popupMessage = editpr ? "PR update queued" : "PR creation queued";
        const popupDescription = editpr 
          ? `${selectedPRCode || 'PR'} will be updated when online`
          : `${selectedPRCode || 'PR'} will be created when online`;
        
        console.log('📱 Showing offline popup:', { popupMessage, popupDescription, editpr });
        
        // DON'T refresh from cache here - state was already updated above
        // The optimistic update already updated both cache and state
        // Refreshing here could cause race conditions with useEffect
        console.log('✅ State already updated with optimistic changes, skipping refresh');
        
        // Clear loading and show popup - ensure all state updates happen
        setLoadingPR(false);
        setSuccessPopUp(true);
        setUserPopupHeroText(popupMessage);
        setUserPopupdescription(popupDescription);
        
        // Close form and reset all states (same as online mode)
        setProceedRFQ(false);
        setViewPR(false);
        setViewRaisedPR(false);
        if (editpr) {
          setEditPR(false);
        }
        
        console.log('✅ Popup state updated - form closed, should show now');
        
        return; // Exit early - action is queued
      }

      // ONLINE MODE: Make API call directly
      try {
        const response = await axios.post(
          API_ENDPOINT.ins_purchase_request,
          formData,
          {
            headers: {
              Authorization: `Bearer ${auth_token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response?.status === 200) {
          if (!editpr) {
            await handleSavePRtoRFQ(formData);
          } else {
            setSuccessPopUp(true);
            setUserPopupHeroText("PR updated successfully");
            setUserPopupdescription(`${selectedPRCode} updated successfully`);
            getAllPurchaseRequest();
            setProceedRFQ(false);
          }
        }
      } catch (apiError) {
        // Check if it's a network/server error (server unreachable)
        const isNetworkError = 
          apiError?.code === 'ERR_NETWORK' || 
          apiError?.code === 'ERR_CONNECTION_REFUSED' ||
          apiError?.message?.includes('Network Error') ||
          apiError?.message?.includes('Connection refused');

        if (isNetworkError) {
          // Server unreachable - queue the action as offline
          console.log('📴 Server unreachable - queuing PR action as offline');
          
          try {
            const actionType = editpr ? 'update' : 'create';
            await offlineQueue.enqueue(
              actionType,
              API_ENDPOINT.ins_purchase_request,
              formData
            );

            // Optimistic cache update
            try {
              const cachedPRs = await prRepository.getAllFromCache();
              
              if (editpr && getprtoken?.pr_token) {
                // UPDATE EXISTING PR
                const prIndex = cachedPRs.findIndex(pr => pr.pr_token === getprtoken.pr_token);
                
                if (prIndex !== -1) {
                  const updatedPR = {
                    ...cachedPRs[prIndex],
                    request_reason: reasontext,
                    dept_name: selectedDepartment?.name || "",
                    items: items.map((item, idx) => {
                      const budgetRow = budgetRows[idx] || {};
                      return {
                        item_token: item.itemToken || cachedPRs[prIndex].items?.[idx]?.item_token || "",
                        item_name: item.itemName || "",
                        item_code: item.itemCode || "",
                        hsn_code: item.hsnCode || "",
                        quantity: item.quantity || "",
                        unit: item.unit || "",
                        part_number: item.partnumber || "",
                        description: item.description || "",
                        unit_price: parseFloat(item.unitPrice || 0),
                        total_price: parseFloat(item.totalPrice || 0),
                        cost_center: budgetRow.costCentre?.costcenter_code || budgetRow.costCentre || "",
                        gl_code: budgetRow.glCode?.gl_code || budgetRow.glCode || "",
                        project_code: budgetRow.projectCode?.project_code || budgetRow.projectCode || "",
                      };
                    }),
                    approvers: selectedApprovers.map(approver => ({
                      id: approver.id,
                      first_name: approver.first_name,
                      last_name: approver.last_name,
                      email: approver.email,
                      designation: approver.designation,
                      phone_number: approver.phone_number,
                      status: approver.status || 'Pending',
                    })),
                  };

                  const transformedPRs = prRepository.transformCombinedPRData([updatedPR]);
                  cachedPRs[prIndex] = transformedPRs[0];
                  await prRepository.saveToCache(cachedPRs);
                  setPurchaseRequestData(cachedPRs);
                }
              } else {
                // CREATE NEW PR
                const tempPRToken = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
                const prCode = selectedPRCode || generatePRCode();
                const now = new Date();
                
                const newPR = {
                  pr_token: tempPRToken,
                  pr_code: prCode,
                  request_reason: reasontext,
                  dept_name: selectedDepartment?.name || "",
                  created_on: now.toISOString().split('T')[0],
                  shipping_address: "",
                  buyer_token: user_token,
                  buyer_role: loginData?.access_type || "User",
                  buyer_user: {
                    first_name: loginData?.user?.first_name || "",
                    last_name: loginData?.user?.last_name || "",
                    email: loginData?.user?.email || "",
                    phone_number: loginData?.user?.phone_number || "",
                    designation: loginData?.user?.designation || "",
                    department: loginData?.user?.department || "",
                    company_name: loginData?.user?.company_name || "",
                    city: loginData?.user?.city || "",
                    state: loginData?.user?.state || "",
                    country: loginData?.user?.country || "",
                    postal_code: loginData?.user?.postal_code || "",
                    address_line: loginData?.user?.address_line || "",
                  },
                  items: items.map((item, idx) => {
                    const budgetRow = budgetRows[idx] || {};
                    return {
                      item_token: item.itemToken || "",
                      item_name: item.itemName || "",
                      item_code: item.itemCode || "",
                      hsn_code: item.hsnCode || "",
                      quantity: item.quantity || "",
                      unit: item.unit || "",
                      part_number: item.partnumber || "",
                      description: item.description || "",
                      unit_price: parseFloat(item.unitPrice || 0),
                      total_price: parseFloat(item.totalPrice || 0),
                      cost_center: budgetRow.costCentre?.costcenter_code || budgetRow.costCentre || "",
                      gl_code: budgetRow.glCode?.gl_code || budgetRow.glCode || "",
                      project_code: budgetRow.projectCode?.project_code || budgetRow.projectCode || "",
                      created_date: now.toISOString().split('T')[0],
                      updated_date: now.toISOString().split('T')[0],
                    };
                  }),
                  approvers: selectedApprovers.map(approver => ({
                    id: approver.id,
                    first_name: approver.first_name,
                    last_name: approver.last_name,
                    email: approver.email,
                    designation: approver.designation,
                    phone_number: approver.phone_number,
                    status: approver.status || 'Pending',
                  })),
                  _pendingSync: true,
                  _tempToken: tempPRToken,
                };

                const transformedPRs = prRepository.transformCombinedPRData([newPR]);
                const updatedPRs = [...cachedPRs, transformedPRs[0]];
                await prRepository.saveToCache(updatedPRs);
                setPurchaseRequestData(updatedPRs);
              }
            } catch (cacheError) {
              console.error('Error updating cache optimistically:', cacheError);
            }

            // Show success message
            const popupMessage = editpr ? "PR update queued" : "PR creation queued";
            const popupDescription = editpr 
              ? `${selectedPRCode || 'PR'} will be updated when server is available`
              : `${selectedPRCode || 'PR'} will be created when server is available`;
            
            getAllPurchaseRequest();
            setLoadingPR(false);
            setSuccessPopUp(true);
            setUserPopupHeroText(popupMessage);
            setUserPopupdescription(popupDescription);
            setProceedRFQ(false);
            setViewPR(false);
            setViewRaisedPR(false);
            if (editpr) {
              setEditPR(false);
            }
            
            return; // Exit early - action is queued
          } catch (queueError) {
            console.error('Error queuing action after network error:', queueError);
            // Fall through to show error message
          }
        }

        // Other errors (not network) - show error message
        console.error("Error saving PR:", apiError.response?.data || apiError.message);
        const errorMessage =
          apiError.response?.data?.response ||
          apiError.message ||
          "Please attach the file";
        setFileuploadError(errorMessage);
      }
    } catch (error) {
      console.error("Error in handleSavePurchaseRequest:", error.response?.data || error.message);
      const errorMessage =
        error.response?.data?.response ||
        error.message ||
        "An error occurred";
      setFileuploadError(errorMessage);
    } finally {
      setLoadingPR(false);
    }
  };

  const handleApprovePR = async (pr_token, bool) => {
    try {
      const response = await axios.post(
        API_ENDPOINT.approve_pr,
        {
          user_token,
          pr_token,
          status: bool,
        },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      if (response.status === 200) {
        get_user_mapped_prs();
      }
    } catch (error) {
      console.error("Error approving PR:", error);
    }
  };

  const handleSavePRtoRFQ = async (formData) => {
    try {
      formData.append("RFQ Code", generatePRCode());

      const response = await axios.post(API_ENDPOINT.save_quick_rfq, formData, {
        headers: {
          Authorization: `Bearer ${auth_token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response?.status === 200) {
        sendNewRFQToken(response?.data?.rfq_token);
        setSuccessPopUp(true);
        setUserPopupHeroText("PR created successfully");
        setUserPopupdescription(`${selectedPRCode} is now available in RFQ`);
        getAllPurchaseRequest();
        setProceedRFQ(false);
      }
    } catch (error) {
      console.error("Error saving RFQ:", error.response?.data || error.message);
    }
  };

  const sendNewRFQToken = async (token) => {
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.rfq_newversion_chatgpt}`,
      data: {
        rfq_token: token,
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSwitch = async (item, editpr = false) => {
    try {
      let deptList = departmentList;
      if (deptList.length === 0) {
        const deptResponse = await axios.post(
          `${API_ENDPOINT.get_Department}`,
          { user_token: user_token },
          { headers: { Authorization: `Bearer ${auth_token}` } }
        );
        deptList = deptResponse.data?.data || [];
        setDepartmentList(deptList);
      }

      let costCenterList = constcenter;
      let glCodeList = glcode;
      let projectCodeList = projectcode;

      if (
        costCenterList.length === 0 ||
        glCodeList.length === 0 ||
        projectCodeList.length === 0
      ) {
        const [costCenterRes, glCodeRes, projectCodeRes] = await Promise.all([
          costCenterList.length === 0
            ? costcentreRequest()
            : Promise.resolve(costCenterList),
          glCodeList.length === 0
            ? glcodeRequest()
            : Promise.resolve(glCodeList),
          projectCodeList.length === 0
            ? projectCodeRequest()
            : Promise.resolve(projectCodeList),
        ]);

        costCenterList = costCenterRes;
        glCodeList = glCodeRes;
        projectCodeList = projectCodeRes;
      }

      // Try to get PR data from combined cache first (offline-first)
      // Combined API has all PRs with full details, so check there first
      let prData = null;
      let itemList = [];
      
      // First, try to get from combined PR cache (from purchaseRequests store)
      const cachedPRs = await prRepository.getAllFromCache();
      const cachedPR = cachedPRs.find(pr => pr.pr_token === item.pr_token);
      
      if (cachedPR) {
        prData = cachedPR;
        itemList = cachedPR.items || [];
      } else {
        // Fallback to individual PR cache
        prData = await prRepository.getIndividualPRFromCache(item.pr_token);
        itemList = prData?.items || [];
      }
      
      // If no cached data or online, try to sync from API
      // BUT: Don't overwrite if PR has pending sync (optimistic update)
      const hasPendingSync = cachedPR?._pendingSync || cachedPR?._lastUpdated;
      
      if (!prData || (navigator.onLine && !hasPendingSync)) {
        try {
          // Try individual API first (more specific)
          const syncedData = await prRepository.syncIndividualPRFromAPI(
            auth_token,
            item.pr_token
          );
          if (syncedData) {
            // Only use synced data if it's newer than our optimistic update
            if (!hasPendingSync || (syncedData.updated_date && cachedPR?.updated_date && 
                new Date(syncedData.updated_date) > new Date(cachedPR.updated_date))) {
              prData = syncedData;
              itemList = syncedData?.items || [];
              console.log('✅ Using synced data from API');
            } else {
              console.log('⚠️ Keeping optimistic update - API data is older');
            }
          }
        } catch (error) {
          console.error('Error syncing individual PR:', error);
          // Continue with cached data if API fails
        }
      } else if (hasPendingSync) {
        console.log('📱 Using cached data with pending sync (optimistic update)');
      }
      
      // If still no data, fallback to direct API call (for backward compatibility)
      if (!prData) {
        const response = await axios({
          method: "POST",
          url: `${API_ENDPOINT.purchase_request_individual_items_view}`,
          data: {
            pr_token: item.pr_token,
          },
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        });
        prData = response.data?.response;
        itemList = response.data?.response?.items || [];
        
        // Cache the response for future use
        if (prData) {
          await prRepository.saveIndividualPRToCache(item.pr_token, prData);
        }
      }
      
      setReasonText(prData?.request_reason || "");

      const formattedItems = itemList.map((item) => ({
        itemName: item.item_name || "",
        itemCode: item.item_code || "",
        quantity: item.quantity || "",
        unit: item.unit || "",
        hsnCode: item.hsn_code || "",
        partnumber: item.part_number || "",
        description: item.description || "",
        unitPrice: parseFloat(item.unit_price || 0),
        totalPrice: parseFloat(item.total_price || 0),
      }));

      const budgetFormatted = itemList.map((item) => ({
        costCentre:
          costCenterList.find((c) => c.costcenter_code === item.cost_center) ||
          null,
        glCode: glCodeList.find((g) => g.gl_code === item.gl_code) || null,
        projectCode:
          projectCodeList.find((p) => p.project_code === item.project_code) ||
          null,
      }));

      setBudgetRows(budgetFormatted);
      setItems(formattedItems);
      setSelectedPRCode(prData?.pr_code || "");
      setBuyerUserDetails(prData?.buyer_user || {});
      
      // Set PR date if available - check item first (from list), then prData
      const dateField = item?.created_on || 
                       prData?.created_on || 
                       prData?.request_date || 
                       prData?.date || 
                       prData?.created_date ||
                       prData?.date_of_request;
      
      if (dateField) {
        setPRDate(dateField);
      } else {
        setPRDate(null);
      }
      const approvers = (prData.approvers || []).map((approver) => ({
        first_name: approver.first_name,
        last_name: approver.last_name,
        email: approver.email,
        designation: approver.designation,
        phone_number: approver.phone_number,
        status: approver.status || 'Pending', // Default to Pending if missing
      }));

      const selectedDept =
        deptList.find((dep) => dep.name === prData?.dept_name) || null;
      setSelectedDepartment(selectedDept);

      setSelectedApprovers(approvers);

      setProceedRFQ(true);
      setViewPR(true);
      setViewRaisedPR(true);
      setEditPR(editpr);
    } catch (error) {
      console.log(error);
    }
  };

  const handleBack = () => {
    getAllPurchaseRequest();
    getPRforCode();
    get_user_mapped_prs();
    setProceedRFQ(false);
    setViewPR(false);
    setViewRaisedPR(false);
    // Clear pr_token when going back (in case user creates new PR after)
    setPRToken({ pr_token: "" });
    setEditPR(false);

    setReasonText("");
    setItems([
      {
        itemName: "",
        itemCode: "",
        quantity: "",
        unit: "",
        hsnCode: "",
        partnumber: "",
        description: "",
        unitPrice: "",
        totalPrice: "",
      },
    ]);
    setBudgetRows([{ costCentre: "", projectCode: "", glCode: "" }]);
    setSelectedPRCode("");
    setBuyerUserDetails({});
    setFileUpload(null);
    setInputMethod("xls");
    setSelectedApprovers([]);
    setSuccessPopUp(false);
    setPRDate(null);
  };

  const handleRaisePR = () => {
    // Clear pr_token when creating a new PR (not editing)
    setPRToken({ pr_token: "" });
    setEditPR(false);
    setPRCode(generatePRCode());
    setProceedRFQ(true);
    setViewPR(false);
    setEditPR(false);
  };

  const handleViewPR = (item) => {
    handleSwitch(item);
    setProceedRFQ(true);
    setViewPR(true);
    setEditPR(false);
  };

  const handleEditPR = (item) => {
    setPRToken((prevToken) => ({ ...prevToken, pr_token: item.pr_token }));
    handleSwitch(item, true);
    setProceedRFQ(true);
    setViewPR(false);
    setEditPR(true);
  };

  const handleRemoveApprover = (index) => {
    const updatedApprovers = [...selectedApprovers];
    updatedApprovers.splice(index, 1);
    setSelectedApprovers(updatedApprovers);
  };

  const showItemSection = proceedRFQ && !viewraisedpr;

  const access_type = loginData?.access_type;
  const userName = loginData?.user?.first_name?.toLowerCase();

  const isApprover = getpurchaserequestdata?.some((pr) =>
    pr.approvers?.some((a) => a.name?.toLowerCase().includes(userName))
  );

  // Clear search function
  const handleClearSearch = () => {
    setSearchTerm("");
    setStatusFilter("all");
  };

  function PaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
      onPageChange(event, lastPage);
    };

    const isBackDisabled = page === 0;
    const isNextDisabled = page >= Math.ceil(count / rowsPerPage) - 1;

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={isBackDisabled}
          aria-label="first page"
          size="medium"
          sx={{ p: 1.25 }}
        >
          {theme.direction === "rtl" ? (
            <LastPageIcon sx={{ fontSize: 24 }} />
          ) : (
            <FirstPageIcon sx={{ fontSize: 24 }} />
          )}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={isBackDisabled}
          aria-label="previous page"
          size="medium"
          sx={{ p: 1.25 }}
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight sx={{ fontSize: 24 }} />
          ) : (
            <KeyboardArrowLeft sx={{ fontSize: 24 }} />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={isNextDisabled}
          aria-label="next page"
          size="medium"
          sx={{ p: 1.25 }}
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft sx={{ fontSize: 24 }} />
          ) : (
            <KeyboardArrowRight sx={{ fontSize: 24 }} />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={isNextDisabled}
          aria-label="last page"
          size="medium"
          sx={{ p: 1.25 }}
        >
          {theme.direction === "rtl" ? (
            <FirstPageIcon sx={{ fontSize: 24 }} />
          ) : (
            <LastPageIcon sx={{ fontSize: 24 }} />
          )}
        </IconButton>
      </Box>
    );
  }

  return (
    <div>
      {!proceedRFQ && (
        <div style={{ padding: "15px" }}>
          <div className={classes.spacebetween}>
            <HeaderTitle titleText={"Purchase Requisition Details"} />

            {user_access_type === "User" &&
              !getpurchaserequestdata.some((pr) =>
                pr.approvers?.some((a) =>
                  a.name
                    ?.toLowerCase()
                    .includes(loginData.user.first_name.toLowerCase())
                )
              ) && (
                <Dbutton label={"Raise PR"} onClick={() => handleRaisePR()} />
              )}
          </div>

          {/* Search and Filter Section */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            {/* Search Bar */}
            <Box sx={{ flex: 1, minWidth: "300px" }}>
              <SearchBar
                value={searchTerm}
                onChange={(query) => setSearchTerm(query)}
                placeholder="Search PR Code, Item, or Buyer..."
              />
            </Box>

            {/* Status Filter - Available for all users */}
            <Box>
              <FormControl
                size="small"
                sx={{ minWidth: 180, bgcolor: "white", borderRadius: 1 }}
              >
                <InputLabel sx={{ fontSize: "12px" }}>
                  Filter by Status
                </InputLabel>
                <Select
                  value={statusFilter}
                  label="Filter by Status"
                  onChange={(e) => setStatusFilter(e.target.value)}
                  sx={{ fontSize: "12px", height: "40px" }}
                >
                  <MenuItem value="all" sx={{ fontSize: "12px" }}>
                    All Status
                  </MenuItem>
                  <MenuItem value="1" sx={{ fontSize: "12px" }}>
                    Approved
                  </MenuItem>
                  <MenuItem value="2" sx={{ fontSize: "12px" }}>
                    Pending
                  </MenuItem>
                  <MenuItem value="3" sx={{ fontSize: "12px" }}>
                    Rejected
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Clear Filters Button - Shows when search or filter is active */}
            {(searchTerm || statusFilter !== "all") && (
              <IconButton
                onClick={handleClearSearch}
                size="small"
                sx={{
                  color: "gray",
                  border: "1px solid #ddd",
                  borderRadius: 1,
                  padding: "8px",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                    color: "red",
                  },
                }}
                title="Clear all filters"
              >
                <CancelIcon fontSize="small" />
              </IconButton>
            )}
          </Box>

          <TableContainer
            component={Paper}
            sx={{
              maxHeight: 420,
              borderRadius: 2,
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
              overflowX: "auto",
              "&::-webkit-scrollbar": { height: 6 },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#c1c1c1",
                borderRadius: 3,
              },
            }}
          >
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  {[
                    "PR Code",
                    "Item Name",
                    "Item Code",
                    "Quantity",
                    "Raised By",
                    "Created On",
                    "Status",
                    "Action",
                  ].map((header) => (
                    <TableCell
                      key={header}
                      sx={{
                        fontWeight: 600,
                        fontSize: "13px",
                        color: "#1a1a1a",
                        textAlign: "left",
                        backgroundColor: "#e8f0f4",
                        borderBottom: "2px solid #d3e0e8",
                        whiteSpace: "nowrap",
                        py: 1,
                        px: 1,
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}

                  {isApprover && (
                    <TableCell
                      sx={{
                        fontWeight: 600,
                        fontSize: "13px",
                        color: "#1a1a1a",
                        textAlign: "left",
                        backgroundColor: "#e8f0f4",
                        borderBottom: "2px solid #d3e0e8",
                        whiteSpace: "nowrap",
                        py: 1,
                        px: 1,
                      }}
                    >
                      Approve / Reject
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>

              <TableBody>
                {(loadingPRs || offlineLoading) ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <CircularProgress />
                      <Typography
                        variant="body2"
                        sx={{ marginTop: 2, fontSize: "14px", color: "#555" }}
                      >
                        Loading Purchase Requisitions...
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : filteredPRs.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      {searchTerm || statusFilter !== "all"
                        ? "No matching PR records found."
                        : "No PR records found."}
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedPurchaseRequests.map((pr, index) => {
                    const isApprover = pr.approvers?.some((a) =>
                      a.name
                        ?.toLowerCase()
                        .includes(loginData.user.first_name.toLowerCase())
                    );
                    const currentApprover = pr.approvers?.find((a) =>
                      a.name
                        ?.toLowerCase()
                        .includes(loginData.user.first_name.toLowerCase())
                    );

                    return (
                      <TableRow
                        key={index}
                        hover
                        sx={{
                          "&:hover": { backgroundColor: "#f9fbfd" },
                          transition: "0.2s ease",
                        }}
                      >
                        <TableCell
                          sx={{ fontSize: "12.5px", textAlign: "left", px: 1 }}
                        >
                          {pr.pr_code}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: "12.5px", textAlign: "left", px: 1 }}
                        >
                          {pr.items?.[0]?.item_name || "—"}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: "12.5px", textAlign: "left", px: 1 }}
                        >
                          {pr.items?.[0]?.item_code || "—"}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: "12.5px", textAlign: "left", px: 1 }}
                        >
                          {pr.items?.[0]?.quantity || "—"}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: "12.5px", textAlign: "left", px: 1 }}
                        >
                          {pr.buyer_name}
                        </TableCell>
                        <TableCell
                          sx={{ fontSize: "12.5px", textAlign: "left", px: 1 }}
                        >
                          {pr.created_on}
                        </TableCell>

                        <TableCell
                          sx={{
                            fontSize: "12.5px",
                            textAlign: "center",
                            px: 1,
                          }}
                        >
                          <Tooltip
                            title={
                              <Box sx={{ p: 0.5 }}>
                                {pr.approvers && pr.approvers.length > 0 ? (
                                  pr.approvers.map((a, idx) => (
                                    <Typography
                                      key={idx}
                                      variant="body2"
                                      sx={{
                                        fontSize: "13px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        color:
                                          a.status === "Approved"
                                            ? "lightgreen"
                                            : a.status === "Cancelled"
                                            ? "red"
                                            : "orange",
                                      }}
                                    >
                                      <strong>{a.name}</strong>: {a.status}
                                    </Typography>
                                  ))
                                ) : (
                                  <Typography
                                    variant="body2"
                                    sx={{ fontSize: "13px" }}
                                  >
                                    No approvers found
                                  </Typography>
                                )}
                              </Box>
                            }
                            placement="top"
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  fontSize: "13px",
                                  backgroundColor: "#333",
                                  color: "#fff",
                                  borderRadius: "6px",
                                  p: "8px 12px",
                                  boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                                },
                              },
                            }}
                          >
                            <Typography
                              sx={{
                                textAlign: "left",
                                fontWeight: 600,
                                fontSize: "13px",
                                cursor: "pointer",
                                color:
                                  pr.pr_approval_status === "Approved"
                                    ? "green"
                                    : pr.pr_approval_status === "Cancelled" ||
                                      pr.pr_approval_status === "Rejected"
                                    ? "red"
                                    : "#f39c12",
                                "&:hover": { textDecoration: "underline" },
                              }}
                            >
                              {pr.pr_approval_status}
                            </Typography>
                          </Tooltip>
                        </TableCell>

                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            px: 1,
                            py: 0.3,
                            textAlign: "left",
                          }}
                        >
                          <IconButton
                            onClick={() => handleViewPR(pr)}
                            size="small"
                            sx={{
                              color: "#1976d2",
                              "&:hover": {
                                backgroundColor: "rgba(25,118,210,0.1)",
                              },
                            }}
                          >
                            <VisibilityIcon fontSize="large" />
                          </IconButton>
                          {user_access_type !== "Buyer" && !isApprover && (
                            <IconButton
                              onClick={() => handleEditPR(pr, true)}
                              size="small"
                              sx={{
                                color: "#1976d2",
                                "&:hover": {
                                  backgroundColor: "rgba(25,118,210,0.1)",
                                },
                              }}
                            >
                              <EditNote fontSize="large" />
                            </IconButton>
                          )}
                        </TableCell>

                        {isApprover && (
                          <TableCell
                            align="left"
                            sx={{
                              whiteSpace: "nowrap",
                              px: 1,
                              py: 0.3,
                              textAlign: "center",
                            }}
                          >
                            {pr.pr_approval_status === "Pending" ? (
                              currentApprover?.status === "Approved" ? (
                                <Chip
                                  label="Approved"
                                  color="success"
                                  size="small"
                                  sx={{
                                    fontWeight: 600,
                                    fontSize: "11px",
                                    borderRadius: "5px",
                                    height: 22,
                                  }}
                                />
                              ) : currentApprover?.status === "Cancelled" ? (
                                <Chip
                                  label="Rejected"
                                  color="error"
                                  size="small"
                                  sx={{
                                    fontWeight: 600,
                                    fontSize: "11px",
                                    borderRadius: "5px",
                                    height: 22,
                                  }}
                                />
                              ) : (
                                <Stack
                                  direction="row"
                                  spacing={0.5}
                                  justifyContent="center"
                                  alignItems="center"
                                >
                                  <Chip
                                    label="Approve"
                                    color="primary"
                                    variant="outlined"
                                    size="small"
                                    clickable
                                    onClick={() =>
                                      handleApprovePR(pr.pr_token, 1)
                                    }
                                    sx={{
                                      fontWeight: 600,
                                      fontSize: "11px",
                                      borderRadius: "5px",
                                      height: 22,
                                      px: 1,
                                    }}
                                  />
                                  <Chip
                                    label="Reject"
                                    variant="outlined"
                                    size="small"
                                    color="error"
                                    clickable
                                    onClick={() =>
                                      handleApprovePR(pr.pr_token, 3)
                                    }
                                    sx={{
                                      fontWeight: 600,
                                      fontSize: "11px",
                                      borderRadius: "5px",
                                      height: 22,
                                      px: 1,
                                    }}
                                  />
                                </Stack>
                              )
                            ) : (
                              <Typography
                                sx={{
                                  color: "text.secondary",
                                  fontSize: "12px",
                                }}
                              >
                                —
                              </Typography>
                            )}
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          {!loadingPRs && filteredPRs.length > 0 && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <TablePagination
                component="div"
                count={filteredPRs.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 50]}
                showFirstButton
                showLastButton
                ActionsComponent={PaginationActions}
                sx={{
                  "& .MuiTablePagination-toolbar": { fontSize: "14px" },
                  "& .MuiTablePagination-selectLabel": { fontSize: "14px" },
                  "& .MuiTablePagination-displayedRows": { fontSize: "14px" },
                  "& .MuiTablePagination-select": { fontSize: "14px" },
                  "& .MuiIconButton-root": { fontSize: "14px" },
                }}
              />
            </Box>
          )}
        </div>
      )}

      {proceedRFQ && (
        <div>
          <div className={classes.spacebetween}>
            <HeaderTitle titleText={"Requested Details"} />
            <Dbutton label={"Back"} onClick={() => handleBack()} />
          </div>

          <div className={classes.spacebetween}>
            {infoLabelDetails.map((items, index) => {
              return (
                <InfoLabel
                  key={index}
                  label={items.label}
                  value={items.value}
                  size={items.size}
                />
              );
            })}
          </div>

          <div
            style={{ flex: "1", display: "flex", flexDirection: "column" }}
            className={`${classes.margincls} `}
          >
            <label style={{ fontSize: "14px", fontWeight: "600" }}>
              Reason / Justification
            </label>
            <textarea
              rows={5}
              style={{ padding: "10px", borderRadius: "5px" }}
              value={reasontext}
              onChange={(e) => setReasonText(e.target.value)}
              disabled={viewpr && !editpr}
            />
          </div>

          <div>
            <HeaderTitle titleText={"Item Details"} />
            {showItemSection && (
              <>
                <div className={classes.margincls}>
                  <RadioGroup
                    row
                    value={inputMethod}
                    onChange={(e) => setInputMethod(e.target.value)}
                  >
                    <FormControlLabel
                      value="xls"
                      control={<Radio />}
                      label="Attach RFQ document"
                      sx={{ "& .MuiTypography-root": { fontSize: "14px" } }}
                    />
                    <FormControlLabel
                      value="manual"
                      control={<Radio />}
                      label="Type details of RFQ"
                      sx={{ "& .MuiTypography-root": { fontSize: "14px" } }}
                    />
                  </RadioGroup>
                </div>

                {inputMethod === "xls" ? (
                  <div className={classes.itemform} style={{ margin: "10px" }}>
                    <div
                      className={`${classes.fileUploadWrapper} ${
                        dragging ? classes.drag_over : ""
                      }`}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                    >
                      <div className={classes.file_upload}>
                        <label className={classes.DocText}>
                          <span>
                            {fileUpload
                              ? fileUpload.name
                              : "Drag and drop file here"}
                          </span>
                          <input
                            type="file"
                            accept=".csv,.xlsx"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                          />
                          <p>(Supported format CSV/Excel)</p>
                        </label>
                        {!fileUpload ? (
                          <button
                            onClick={() =>
                              document
                                .querySelector('input[type="file"]')
                                .click()
                            }
                          >
                            Browse
                          </button>
                        ) : (
                          <button onClick={() => setFileUpload(null)}>
                            Clear
                          </button>
                        )}
                      </div>
                      {fileuploadError && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "14px",
                            marginTop: "8px",
                            padding: "8px",
                          }}
                        >
                          {fileuploadError}
                        </div>
                      )}
                    </div>
                    <span className={classes.margincls}>
                      <p
                        className={classes.linkBtn}
                        onClick={() => {
                          saveAs(PRSampleItemsList, "Sample CSV.csv");
                        }}
                      >
                        Sample CSV
                      </p>
                    </span>
                  </div>
                ) : (
                  <div style={{ padding: "10px 10px" }}>
                    {items.map((item, index) => (
                      <Paper
                        key={index}
                        elevation={2}
                        sx={{
                          p: 3,
                          mb: 3,
                          borderRadius: 2,
                          backgroundColor: "#fafafa",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 2,
                            mb: 2,
                          }}
                        >
                          <Box sx={{ flex: 1, minWidth: "200px" }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                            >
                              Part Number (Optional)
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              placeholder="Part number"
                              value={item.partNumber || ""}
                              onChange={(e) =>
                                updateTotalPrice(
                                  index,
                                  "partNumber",
                                  e.target.value
                                )
                              }
                              sx={{
                                "& .MuiInputBase-input": {
                                  fontSize: "16px",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                  fontSize: "14px",
                                  color: "#999",
                                },
                              }}
                            />
                          </Box>

                          <Box sx={{ flex: 1, minWidth: "200px" }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                            >
                              Item Code
                            </Typography>
                            <Autocomplete
                              options={getItemMaster}
                              getOptionLabel={(option) =>
                                option.item_code || ""
                              }
                              value={
                                getItemMaster.find(
                                  (i) => i.item_code === item.itemCode
                                ) || null
                              }
                              onChange={(e, newValue) =>
                                handleItemSelection(index, newValue)
                              }
                              isOptionEqualToValue={(option, value) => {
                                if (option?.item_token && value?.item_token) {
                                  return option.item_token === value.item_token;
                                }
                                if (option?.id && value?.id) {
                                  return option.id === value.id;
                                }
                                return option?.item_code === value?.item_code;
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Select item code"
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      fontSize: "16px",
                                    },

                                    "& .MuiInputBase-input::placeholder": {
                                      fontSize: "14px",
                                      color: "#999",
                                    },
                                  }}
                                />
                              )}
                            />
                          </Box>

                          <Box sx={{ flex: 1, minWidth: "200px" }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                            >
                              Item Name
                            </Typography>
                            <Autocomplete
                              options={getItemMaster}
                              getOptionLabel={(option) =>
                                option.item_name || ""
                              }
                              value={
                                getItemMaster.find(
                                  (i) => i.item_name === item.itemName
                                ) || null
                              }
                              onChange={(e, newValue) =>
                                handleItemSelection(index, newValue)
                              }
                              isOptionEqualToValue={(option, value) => {
                                if (option?.item_token && value?.item_token) {
                                  return option.item_token === value.item_token;
                                }
                                if (option?.id && value?.id) {
                                  return option.id === value.id;
                                }
                                return option?.item_name === value?.item_name;
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Select item name"
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      fontSize: "16px",
                                    },
                                    "& .MuiInputBase-input::placeholder": {
                                      fontSize: "14px",
                                      color: "#999",
                                    },
                                  }}
                                />
                              )}
                            />
                          </Box>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 2,
                            mb: 2,
                          }}
                        >
                          <Box sx={{ flex: 1, minWidth: "200px" }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                            >
                              Quantity
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              type="number"
                              placeholder="Quantity"
                              value={item.quantity}
                              onChange={(e) =>
                                updateTotalPrice(
                                  index,
                                  "quantity",
                                  e.target.value
                                )
                              }
                              sx={{
                                "& .MuiInputBase-input": {
                                  fontSize: "16px",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                  fontSize: "14px",
                                  color: "#999",
                                },
                              }}
                            />
                          </Box>

                          <Box sx={{ flex: 1, minWidth: "200px" }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                            >
                              Unit Measure
                            </Typography>
                            <Autocomplete
                              disablePortal
                              options={unitsOptions}
                              value={item.unit || ""}
                              onChange={(e, newValue) => {
                                const updated = [...items];
                                updated[index].unit = newValue;
                                setItems(updated);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  placeholder="Select unit"
                                  sx={{
                                    "& .MuiInputBase-input": {
                                      fontSize: "16px",
                                    },
                                    "& .MuiInputBase-input::placeholder": {
                                      fontSize: "14px",
                                      color: "#999",
                                    },
                                  }}
                                />
                              )}
                            />
                          </Box>
                        </Box>

                        <Box sx={{ mb: 2 }}>
                          <Typography fontWeight={600} fontSize="14px" mb={0.5}>
                            Item Description
                          </Typography>
                          <TextField
                            fullWidth
                            multiline
                            rows={3}
                            placeholder="Item description"
                            value={item.description}
                            onChange={(e) =>
                              updateTotalPrice(
                                index,
                                "description",
                                e.target.value
                              )
                            }
                            sx={{
                              "& .MuiInputBase-input": {
                                fontSize: "16px",
                              },
                              "& .MuiInputBase-input::placeholder": {
                                fontSize: "14px",
                                color: "#999",
                              },
                            }}
                          />
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 2,
                            alignItems: "center",
                          }}
                        >
                          <Box sx={{ flex: 1, minWidth: "200px" }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                            >
                              Unit Price
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              type="number"
                              placeholder="Unit price"
                              value={item.unitPrice}
                              onChange={(e) =>
                                updateTotalPrice(
                                  index,
                                  "unitPrice",
                                  e.target.value
                                )
                              }
                              sx={{
                                "& .MuiInputBase-input": {
                                  fontSize: "16px",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                  fontSize: "14px",
                                  color: "#999",
                                },
                              }}
                            />
                          </Box>

                          <Box sx={{ flex: 1, minWidth: "200px" }}>
                            <Typography
                              fontWeight={600}
                              fontSize="14px"
                              mb={0.5}
                            >
                              Total Price
                            </Typography>
                            <TextField
                              fullWidth
                              size="small"
                              value={item.totalPrice}
                              InputProps={{
                                readOnly: true,
                              }}
                              sx={{
                                backgroundColor: "#f5f5f5",
                                "& .MuiInputBase-input": {
                                  fontSize: "16px",
                                },
                                "& .MuiInputBase-input::placeholder": {
                                  fontSize: "14px",
                                  color: "#999",
                                },
                              }}
                            />
                          </Box>
                        </Box>

                        {index > 0 && (
                          <Box sx={{ textAlign: "right", mt: 2 }}>
                            <Dbutton
                              label="Remove"
                              onClick={() => handleRemoveItem(index)}
                            />
                          </Box>
                        )}
                      </Paper>
                    ))}

                    {!viewpr && (
                      <div
                        style={{}}
                        className={`${classes.spacebetween} ${classes.stickyFooter}`}
                      >
                        <InfoLabel
                          label={"Total Price"}
                          value={`₹ ${grandTotal.toFixed(2)}`}
                        />
                        <Dbutton label={"Add Items"} onClick={handleAddItem} />
                      </div>
                    )}
                  </div>
                )}
              </>
            )}

            {viewraisedpr && (
              <div className={classes.margincls}>
                <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontSize: "14px", fontWeight: 600 }}>
                          <strong>Item Code</strong>
                        </TableCell>
                        <TableCell sx={{ fontSize: "14px", fontWeight: 600 }}>
                          <strong>Item Name</strong>
                        </TableCell>
                        <TableCell sx={{ fontSize: "14px", fontWeight: 600 }}>
                          <strong>Quantity</strong>
                        </TableCell>
                        <TableCell sx={{ fontSize: "14px", fontWeight: 600 }}>
                          <strong>Unit</strong>
                        </TableCell>
                        <TableCell sx={{ fontSize: "14px", fontWeight: 600 }}>
                          <strong>Description</strong>
                        </TableCell>
                        <TableCell sx={{ fontSize: "14px", fontWeight: 600 }}>
                          <strong>Unit Price</strong>
                        </TableCell>
                        <TableCell sx={{ fontSize: "14px", fontWeight: 600 }}>
                          <strong>Total Price</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {items.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell sx={{ fontSize: "13px" }}>
                            {item.itemCode}
                          </TableCell>
                          <TableCell sx={{ fontSize: "13px" }}>
                            {item.itemName}
                          </TableCell>
                          <TableCell sx={{ fontSize: "13px" }}>
                            {item.quantity}
                          </TableCell>
                          <TableCell sx={{ fontSize: "13px" }}>
                            {item.unit}
                          </TableCell>
                          <TableCell sx={{ fontSize: "13px" }}>
                            {item.description}
                          </TableCell>
                          <TableCell sx={{ fontSize: "13px" }}>
                            ₹ {parseFloat(item.unitPrice).toFixed(2)}
                          </TableCell>
                          <TableCell sx={{ fontSize: "13px" }}>
                            ₹ {parseFloat(item.totalPrice).toFixed(2)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            )}
          </div>

          {user_access_type !== "Buyer" && (
            <div>
              <HeaderTitle titleText={"Budget"} />

              <div style={{ padding: "10px" }}>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontSize: "14px", fontWeight: 600 }}>
                          <strong>Cost Center Code</strong>
                        </TableCell>
                        <TableCell sx={{ fontSize: "14px", fontWeight: 600 }}>
                          <strong>GL Code</strong>
                        </TableCell>
                        <TableCell sx={{ fontSize: "14px", fontWeight: 600 }}>
                          <strong>Project Code</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {budgetRows.map((row, index) => {
                        return (
                          <TableRow>
                            <TableCell>
                              <Autocomplete
                                options={constcenter}
                                getOptionLabel={(option) =>
                                  option?.costcenter_code || ""
                                }
                                value={row.costCentre}
                                onChange={(e, value) =>
                                  handleChange(index, "costCentre", value)
                                }
                                isOptionEqualToValue={(option, value) => {
                                  if (option?.id && value?.id) {
                                    return option.id === value.id;
                                  }
                                  return option?.costcenter_code === value?.costcenter_code;
                                }}
                                disabled={viewpr && !editpr}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Select Cost Centre"
                                    size="small"
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        fontSize: "14px",
                                      },
                                      "& .MuiInputLabel-root": {
                                        fontSize: "14px",
                                      },
                                      "& .MuiAutocomplete-input": {
                                        fontSize: "14px",
                                      },
                                    }}
                                  />
                                )}
                              />
                            </TableCell>
                            <TableCell>
                              <Autocomplete
                                options={glcode}
                                getOptionLabel={(option) =>
                                  option?.gl_code || ""
                                }
                                value={row.glCode}
                                onChange={(e, value) =>
                                  handleChange(index, "glCode", value)
                                }
                                isOptionEqualToValue={(option, value) => {
                                  if (option?.id && value?.id) {
                                    return option.id === value.id;
                                  }
                                  return option?.gl_code === value?.gl_code;
                                }}
                                disabled={viewpr && !editpr}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Select GL Code"
                                    size="small"
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        fontSize: "14px",
                                      },
                                      "& .MuiInputLabel-root": {
                                        fontSize: "14px",
                                      },
                                      "& .MuiAutocomplete-input": {
                                        fontSize: "14px",
                                      },
                                    }}
                                  />
                                )}
                              />
                            </TableCell>
                            <TableCell>
                              <Autocomplete
                                options={projectcode}
                                getOptionLabel={(option) =>
                                  option?.project_code || ""
                                }
                                value={row.projectCode}
                                onChange={(e, value) =>
                                  handleChange(index, "projectCode", value)
                                }
                                isOptionEqualToValue={(option, value) => {
                                  if (option?.id && value?.id) {
                                    return option.id === value.id;
                                  }
                                  return option?.project_code === value?.project_code;
                                }}
                                disabled={viewpr && !editpr}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Select Project Code"
                                    size="small"
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        fontSize: "14px",
                                      },
                                      "& .MuiInputLabel-root": {
                                        fontSize: "14px",
                                      },
                                      "& .MuiAutocomplete-input": {
                                        fontSize: "14px",
                                      },
                                    }}
                                  />
                                )}
                              />
                            </TableCell>

                            {editpr && (
                              <TableCell>
                                {budgetRows.length > 1 && index > 0 && (
                                  <IconButton
                                    onClick={() => removeBudgetRow(0)}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                )}
                                {index === budgetRows.length - 1 && (
                                  <IconButton onClick={addBudgetRow}>
                                    <AddIcon />
                                  </IconButton>
                                )}
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          )}

          {
            <div>
              {viewraisedpr && <HeaderTitle titleText={"Approvers"} />}

              <div>
                <div className={classes.margincls}>
                  {selectedApprovers.length > 0 && (
                    <TableContainer
                      component={Paper}
                      sx={{ marginTop: "20px" }}
                    >
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{ fontSize: "14px", fontWeight: 600 }}
                            >
                              <strong>First Name</strong>
                            </TableCell>
                            <TableCell
                              sx={{ fontSize: "14px", fontWeight: 600 }}
                            >
                              <strong>Last Name</strong>
                            </TableCell>
                            <TableCell
                              sx={{ fontSize: "14px", fontWeight: 600 }}
                            >
                              <strong>Email</strong>
                            </TableCell>
                            <TableCell
                              sx={{ fontSize: "14px", fontWeight: 600 }}
                            >
                              <strong>Designation</strong>
                            </TableCell>
                            <TableCell
                              sx={{ fontSize: "14px", fontWeight: 600 }}
                            >
                              <strong>Phone Number</strong>
                            </TableCell>
                            {!proceedRFQ && (
                              <TableCell
                                sx={{ fontSize: "14px", fontWeight: 600 }}
                              >
                                <strong>Status</strong>
                              </TableCell>
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selectedApprovers.map((approver, index) => {
                            return (
                              <TableRow key={index}>
                                <TableCell sx={{ fontSize: "13px" }}>
                                  {approver.first_name}
                                </TableCell>
                                <TableCell sx={{ fontSize: "13px" }}>
                                  {approver.last_name || "-"}
                                </TableCell>
                                <TableCell sx={{ fontSize: "13px" }}>
                                  {approver.email || "-"}
                                </TableCell>
                                <TableCell sx={{ fontSize: "13px" }}>
                                  {approver.designation || "-"}
                                </TableCell>
                                <TableCell sx={{ fontSize: "13px" }}>
                                  {approver.phone_number || "-"}
                                </TableCell>
                                {!proceedRFQ && (
                                  <TableCell sx={{ fontSize: "13px" }}>
                                    {approver.status || "Pending"}
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </div>
              </div>
            </div>
          }

          {user_access_type === "User" && proceedRFQ && (editpr || !viewpr) && (
            <div>
              <Dbutton
                label={
                  loadingPR
                    ? editpr
                      ? "Updating..."
                      : "Creating..."
                    : editpr
                    ? "Update PR"
                    : "Create PR"
                }
                onClick={handleSavePurchaseRequest}
                disabled={loadingPR}
              />

              {loadingPR && (
                <CircularProgress size={20} style={{ marginLeft: "10px" }} />
              )}
            </div>
          )}
        </div>
      )}

      <Modal open={successpopup}>
        <Fade in={successpopup}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText={getuserpopupherotext}
              popupDescription={getuserpopupdescription}
              popBtn={true}
              vendorBtn={true}
              btnText={"Okay"}
              btnClick={handleBack}
            />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};
